export const SIDE_BAR_ITEMS = {
  DASHBOARD: "dashboard",
  SCHEDULING: "scheduling",
  STUDENT_MANAGEMENT: "studentManagement",
  INTERVIEW_CONFIG: "interviewConfig",
  INTERVIEW_REVIEWS: "interviewReviews",
  QUESTION_DATABASE: "questionDatabase",
  FEEDBACK_TEMPLATES: "feedbackTemplates",
  CREDIT_MANAGEMENT: "creditManagement",
  TRAINING_MATERIALS: "trainingMaterials",
  ANALYTICS: "analytics",
  UPLOAD_TOOLS: "uploadTools",
  REPORT_EVALUATION: "reportEvaluation",
  SETTINGS: "settings",
  STUDENT_VIEW: "studentView",
};
